import styled, { css, keyframes } from "styled-components"
import { overloadColor } from "../../util/style"

const opacityAnimation = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`

function createSpokes(duration: number) {
  const step = duration / 12
  let divs = ""
  for (let i = 0; i < 12; i++) {
    const dur = -duration + step * (i + 1)

    divs += `
      &:nth-child(${i + 1}) {
        transform: rotate(${i * 30}deg);
        animation-delay: ${dur}s;
      }
    `
  }
  return css`
    ${divs}
  `
}
interface SpinnerWheelProps {
  size: number
  colorPrimary: string
  duration: number
}
export const SpinnerWheel = styled.div<SpinnerWheelProps>`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  transform-origin: 50% 0;
  transform: scale(${(props) => props.size / 80});

  div {
    animation: ${opacityAnimation} ${(props) => props.duration}s linear infinite;
    transform-origin: 40px 40px;

    &::after {
      content: ' ';
      display: block;
      position: absolute;
      top: 3px;
      left: 37px;
      width: 6px;
      height: 18px;
      border-radius: 20%;
      background: ${(props) => overloadColor(props.colorPrimary)};
    }
    ${(props) => createSpokes(props.duration)}
  }
`
